import { connect } from 'react-redux';
import { IStoreState } from 'src/store';
import { FrameworkActionCreator, AppointmentActionCreator, MenusActionCreator, AdditionalServicesActionCreator, VehiclesActionCreator, WebOpsActionCreator, NewVehicleActionCreator, CustomerActionCreator, SpecsActionCreator } from 'src/store/states';
import AddVehicleFooter from 'src/components/AddVehicle/AddVehicleFooter/AddVehicleFooter';

const mapStateToProps = (state: IStoreState) => ({
    newVehicleInfo: state.NewVehicle.NewVehicle,
    vehicleSpecs: state.Specs.specs,
    mainPaneViewOrder: state.Framework.mainPaneViewOrder,
    vehicles: state.Vehicles.vehicles,
    decodeData: state.Vehicles.decodedData,
    specProfile: state.Framework.specProfile,
    store: state.Framework.store,
    branch: state.Framework.branch,
    additionalServices: state.AdditionalServices,
    apptVin: state.Appointment.ApptVeh.vin,
    showWeOwes: state.Specs.specs?.showWeOwes,
    showOEMRecall: state.Specs.specs?.showOEMRecall,
    showPrvRecom: state.Specs.specs?.showPrvRecom,
    inquiryInvoked: state.AdditionalServices.allServices.inquiryInvoked,
    viewMode: state.Framework.viewMode,
    menusReturnCode: state.Menus.allMenus.returnCode,
    currentProperty: state.NewVehicle.CurrentProperty,
    vehSelectedVehicle: state.Vehicles.selectedVehicle!,
    nameId: state.Customer.Customer.nameId,
    skipServices: !(state.Specs.specs?.skipServicesFlag ?? false) && !(state.Specs.specs?.showWrtYourOwn ? true : false) &&
        !(state.Specs.specs?.showDiagnTool ? true : false) && state.WebOps.WebOps?.length === 0 &&
        state.Menus.allMenus.menus.length === 0,
    apptDept: state.Appointment.Appointment.department,
    webOpBuilt: state.WebOps.built.built,
    locale: state.Framework.locale,
    addVinError: state.Vehicles.addVinError,
    TMNAMileage: state.AdditionalServices.maintContractData.TMNAMileage,
    waitOnRecall: state.Framework.waitOnRecall,
    theme: state.Framework.theme,
    countryCode: state.Framework.dealerCountry,
    login: state.Customer.Customer.login,
    multipleCustomers: state.Customer.multipleCustomers,
    sessionId: state.Framework.sessionId,
    lexusMCLaunched: state.Framework.lexusMCLaunched,
    toyotaMCLaunched: state.Framework.toyotaMCLaunched,
    lexusTDMCLaunched: state.Framework.lexusTDMCLaunched,
    toyotaTDMCLaunched: state.Framework.toyotaTDMCLaunched,
    vehicleAddTriggered: state.Framework.vehicleAddTriggered,
});

const mapDispatchToProps = {
    clearNewVehicle: NewVehicleActionCreator.clearNewVehicle,
    updateAppVehicle: AppointmentActionCreator.UpdateApptVehicle,
    pushToMainPane: FrameworkActionCreator.pushToMainPane,
    popFromMainPane: FrameworkActionCreator.popFromMainPane,
    getMenus: MenusActionCreator.GetMenus,
    getAdditionalServices: AdditionalServicesActionCreator.GetAdditionalServices,
    selectVehicle: VehiclesActionCreator.SelectVehicle,
    addVehicle: VehiclesActionCreator.AddVehicle,
    getApptOps: WebOpsActionCreator.GetApptOps,
    clearAdditionalServices: AdditionalServicesActionCreator.ClearAdditionalServices,
    UpdateApptOps: AppointmentActionCreator.UpdateApptOps,
    clearMenusState: MenusActionCreator.ClearMenusState,
    previousProperty: NewVehicleActionCreator.PreviousProperty,
    clearDecodeData: VehiclesActionCreator.ClearDecodeData,
    getDeptSpecs: SpecsActionCreator.GetDeptSpecs,
    clearAddVinError: VehiclesActionCreator.ClearAddVinError,
    getExCust: CustomerActionCreator.GetExCust,
    setAddVehicle: FrameworkActionCreator.SetAddVehicle,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(AddVehicleFooter);